import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  Typography,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from '../Button'
import TabPanel from '../../components/TabPanel';

function CityEditModal(props) {
  const {
    city,
    open,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
    }
  } = props;

  const [name, setName] = useState('');
  const [shortName, setShortName] = useState('');
  const [zipcodes, setZipcodes] = useState('');
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    setName(city.name || '')
    setShortName(city.shortName || '')
    setZipcodes((city.zipcodes || []).join(', '))
  }, [])

  const onSave = () => {
    save({ id: city.id || '', name, shortName, zipcodes: zipcodes.split(',').map(z => z.trim()) });
  };

  const validate = () => {
    let valid = true
    const nextState = {}
    if (!name) {
      nextState.name = 'Required'
      valid = false
    }
    if (!shortName) {
      nextState.shortName = 'Required'
      valid = false
    }
    setValidationErrors(nextState);
    return valid
  }

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>{city.name || 'New City'}</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="City" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <DialogContent>
            <TextField
              fullWidth
              variant="outlined"
              label="Name"
              value={name}
              onChange={event => {
                setName(event.target.value)
                setValidationErrors({ ...validationErrors, name: false })
              }}
              error={validationErrors.name}
              helperText={validationErrors.name}
              className={input}
            />
            <TextField
              disabled={Boolean(city.id)}
              fullWidth
              variant="outlined"
              label="Short Name"
              value={shortName}
              onChange={event => {
                setShortName(event.target.value)
                setValidationErrors({ ...validationErrors, shortName: false })
              }}
              error={validationErrors.shortName}
              helperText={validationErrors.shortName}
              className={input}
            />

            <TextField
              fullWidth
              multiline
              rows="10"
              variant="outlined"
              label="Zip Codes"
              name="zipcodes"
              value={zipcodes}
              className={input}
              onChange={event => setZipcodes(event.target.value)}
            />
            <Typography>Zipcodes must be comma seperated, they can be added or removed.</Typography>
          </DialogContent>

          <Grid
            container
            justifyContent="flex-end"
            classes={{ container: actions }}
          >
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={onSave}
                onClickValidation={validate}
              >
                Save City
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

CityEditModal.propTypes = {
  city: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(CityEditModal);
